var _defs, _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFees = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fab29b;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 241,
    cy: 151,
    r: 109
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.8,52.2c-63.5-.1-115,51.2-115.1,114.7-.1,58.8,44.1,108.1,102.5,114.5,4.2.5,8.4.7,12.6.7,63.5.5,115.3-50.5,115.8-114,.5-63.5-50.5-115.3-114-115.8-.6,0-1.2,0-1.8,0h0ZM255.8,266.8c-3.6,0-7.2-.2-10.8-.6-54.6-6.1-93.8-55.4-87.7-109.9,6.1-54.6,55.4-93.8,109.9-87.7,54.6,6.1,93.8,55.4,87.7,109.9-5.7,50.4-48.4,88.4-99.1,88.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.9,21.7H112.1c-16.6,0-30.1,13.5-30.1,30.1v378.6c0,8.5,4,16.5,10.6,21.6l47.7,36.8c2.5,1.9,6,1.9,8.5,0l51.4-39.6,51.4,39.6c2.5,1.9,6,1.9,8.5,0l51.4-39.6,51.4,39.6c2.5,1.9,6,1.9,8.5,0l47.8-36.8c6.7-5.2,10.6-13.2,10.7-21.6V51.8c0-16.6-13.5-30.1-30.1-30.1h0ZM416,430.4c0,4.1-1.9,8-5.2,10.6l-43.5,33.5-51.4-39.6c-2.5-1.9-6-1.9-8.5,0l-51.4,39.6-51.4-39.6c-2.5-1.9-6-1.9-8.5,0l-51.4,39.6-43.4-33.5c-3.3-2.5-5.2-6.4-5.2-10.6V51.8c0-8.9,7.2-16.1,16.1-16.1h287.8c8.9,0,16.1,7.2,16.1,16.1v378.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.7,303h-117.7c-3.9,0-7,3.1-7,7s3.1,7,7,7h117.7c3.9,0,7-3.1,7-7s-3.1-7-7-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370,303h-58.8c-3.9,0-7,3.1-7,7s3.1,7,7,7h58.8c3.9,0,7-3.1,7-7s-3.1-7-7-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.7,340.7h-117.7c-3.9,0-7,3.1-7,7s3.1,7,7,7h117.7c3.9,0,7-3.1,7-7s-3.1-7-7-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370,340.7h-58.8c-3.9,0-7,3.1-7,7s3.1,7,7,7h58.8c3.9,0,7-3.1,7-7s-3.1-7-7-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.7,378.4h-117.7c-3.9,0-7,3.1-7,7s3.1,7,7,7h117.7c3.9,0,7-3.1,7-7s-3.1-7-7-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370,378.4h-58.8c-3.9,0-7,3.1-7,7s3.1,7,7,7h58.8c3.9,0,7-3.1,7-7s-3.1-7-7-7Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.9,229.9c-1.5,0-3-.8-3.8-2.1l-22.2-33.5c-1.7-2.7-3.5-4.9-5.3-6.6-1.8-1.6-3.9-2.8-6.1-3.5s-4.9-1-8.1-1h-18c-2.5,0-4.6-2.1-4.6-4.6v-1.6c0-2.5,2.1-4.6,4.6-4.6h27.3c8.7,0,15.3-1.8,19.7-5.5,4.1-3.5,6.4-8.4,7-14.9s.6-.9,1.1-.6l1,.6h-56.1c-2.5,0-4.6-2.1-4.6-4.6h0c0-2.5,2.1-4.6,4.6-4.6h56.1l-1.4,1.1c-.4.3-1.1,0-1.2-.4-1-5-3.5-8.9-7.4-11.6-4.2-2.9-10.1-4.4-17.7-4.4h-28.4c-2.5,0-4.6-2.1-4.6-4.6h0c0-2.5,2.1-4.6,4.6-4.6h79c2.5,0,4.6,2.1,4.6,4.6h0c0,2.5-2.1,4.6-4.6,4.6h-27.2l2.5-1.7c.2,0,.5-.2.8,0,3.7,2,6.6,4.6,8.8,7.8,1.9,2.8,3.2,6.1,3.8,9.8s-.7,1.1-1.2.7h0c-.5-.4-.2-1.3.5-1.3h12.1c2.5,0,4.6,2.1,4.6,4.6h0c0,2.5-2.1,4.6-4.6,4.6h-11.7c-.7,0-1-.8-.5-1.3l.2-.2c.5-.4,1.2,0,1.2.5,0,6.1-1.4,11.4-4.1,15.9-2.9,4.9-7.2,8.7-12.9,11.4-5.6,2.6-12.5,3.9-20.4,3.9v-1.4h3c4.2,0,7.9.9,11.1,2.8,3.2,1.9,6.3,5.2,9.4,9.9l19.3,28.9c2,3-.2,7.1-3.8,7.1h-6.4v.4Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFees);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Fees.b38ea5e959c2b83e54035a64c9a38f1b.svg";